import React from "react";
import "../style.css";
// import CookiesConsent from "./cookies-consent";


const  CoookiesPage =() => {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     cookieName: "avicollectweb:cc"
  //   }
  // }
  // let cookieName = "avicollectweb:cc";
  // setCookies = (name, value, days) => {
  //   console.log("set cookies", name, value, days)
  //   let expires = "";
  //   if (days) {
  //     var date = new Date();
  //     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  //     expires = "; expires=" + date.toUTCString();
  //   }
  //   document.cookie = name + "=" + (value || "") + expires + "; path=/";
  //   this.toggleCookieDisplay();
  // };

  //  getCookie = (name) => {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) === " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // };

  //  toggleCookieDisplay = () => {
  //    const {cookieName} = this.state;
  //   let cookieObj = this.getCookie(cookieName);
  //   console.log(cookieObj, typeof cookieObj);
  //   let cookieWrapperElement = document.querySelector(".cookies-poilcy-footer");
  //   if (cookieObj === null) {
  //     console.log("it is null");
  //     cookieWrapperElement.style.display = "flex";
  //   } else {
  //     console.log("it is not null");
  //     cookieWrapperElement.style.display = "none";
  //   }
  // };

  // componentDidMount = () => {
  //     const body = document.body;
  //   body.style.overflow = "scroll";
  //   this.toggleCookieDisplay();
  // }
  // // useEffect(() => {
  // //   const body = document.body;
  // //   body.style.overflow = "scroll";
  // //   toggleCookieDisplay();
  // // });
// render() {
  // const {cookieName} = this.state;
  return (
    <div className="p-5">
       <div>
      <h1>Cookie Policy</h1>
        Please read this cookie policy (“cookie policy”, "policy") carefully
        before using this website (“website”, "service") operated by AviTech ("us",
        'we", "our").
      </div>
      <div className="pt-3">
        <h5>What are Cookies?</h5>
        Cookies are simple text files that are stored on your computer or mobile
        device by a website’s server. Each cookie is unique to your web browser.
        It will contain some anonymous information such as a unique identifier,
        website’s domain name, and some digits and numbers.
      </div>
      <h5 className="pt-3">What type of cookies do we use?</h5>
      <div>
        <h5>Necessary Cookies</h5>
        Necessary cookies allow us to offer you the best possible experience
        when accessing and navigating through our website and using its
        features. For example, these cookies let us recognize that you have
        created an account and have logged into that account.
      </div>
      <div className="pt-3">
        <h5>Functionality Cookies</h5>Functionality cookies let us operate the
        site in accordance with the choices you make. For example, we will
        recognize your username and remember how you customized the site during
        future visits.
      </div>
      <div className="pt-3">
        <h5>Performance Cookies</h5>These are used to gather data on how users
        use our website and the pages visited most often. They monitor only the
        performance of our website as the user interacts with it. All data
        collected by these cookies are anonymous and are solely used to improve
        the functionality of our website.
      </div>
      <div className="pt-3">
        <h5>How to delete Cookies?</h5>If you want to restrict or block the
        cookies that are set by our website, you can do so through your browser
        setting.
      </div>
      <div className="pt-3">
        Contact us If you have any questions about this policy or our use of
        cookies, please contact us at  <a
            href="mailto:dpo@avitechng.com"
            className="text-decoration: underline; color: inherit;"
          >
            dpo@avitechng.com.
          </a>{" "}
      </div>
      <a class='mt-0 mb-0 text-avi-primary pointer' href='/signing'>Back to Login</a>
    </div>
  );
}
// }

export default CoookiesPage;



// WEBPACK FOOTER //
// ./src/views/pages/cookies-page/index.js